import React from 'react'
import WhiteBox from '../../components/WhiteBox'
import AudienceList from '../../components/AudienceList'

export const SelectedAudience = ({ selected }) => (
    <div className="row justify-content-center">
        <div className="col-10 audience-viewer">
            <WhiteBox>
                <h3>AUDIENCE YOU ARE LICENSING</h3>

                <AudienceList audiences={[selected]} showEdit={false} showSelect={false} last_page={true} />
            </WhiteBox>
        </div>
    </div>
)

export const AudienceSelector = ({
    audiences,
    loading,
    last_page,
    onLoadMore,
    selected,
    onSelect,
    sort,
    sortOrder,
    onSortChange,
    filter,
    onFilterChange,
    size,
    offset
}) => (
    <div className="row justify-content-center">
        <div className="col-10">
            <WhiteBox>
                <h3>SELECT AUDIENCE TO LICENSE</h3>

                <div className="row" style={{ marginTop: '40px', padding: '10px' }}>
                    <div className="col">
                        <h3>Filter audiences</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{ margin: '10px' }}>
                        <div className="add-segment add-segment--search-field">
                            <input
                                className="form-control"
                                placeholder="Start typing a audience name…"
                                value={filter}
                                onChange={({ target }) => onFilterChange(target)}
                            />
                        </div>
                    </div>
                </div>

                <hr></hr>

                <AudienceList
                    audiences={audiences}
                    onLoadMore={onLoadMore.bind(this)}
                    loading={loading}
                    sort={sort}
                    sortOrder={sortOrder}
                    onSortChange={onSortChange.bind(this)}
                    last_page={last_page}
                    showEdit={false}
                    showSelect={true}
                    onSelect={onSelect}
                    size={size}
                    offset={offset}
                />
            </WhiteBox>
        </div>
    </div>
)
